<template>
    <div>
        <audio controls controlslist="nodownload noprogress" ref="audio" class="w-full">
            <source :src="audioUrlLive">
        </audio>
    </div>
</template>

<script>
export default {
    props: {
        audioUrl: {
            type: String,
            default: () => { return '' }
        }
    },
    computed: {
        audioUrlLive: function () {
            if (this.audioUrl.includes('http')) {
                return this.audioUrl;
            }
            return `https://staging-strapi.orsai.org/${this.audioUrl}`;
        }
    },
}
</script>

<style lang="scss" scoped></style>